import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import iwaysZhLocale from "iways-ui/lib/locale/lang/zh-CN";
// iways-ui lang
import iwaysEnLocale from "iways-ui/lib/locale/lang/en";
// iways-ui lang
import zhLocale from "./zh_CN";
import enLocale from "./en";
import waysUIZhLocale from "ways-ui-vue/lib/locale-provider/zh_CN"; // ways-ui-vue lang
import waysUIEnLocale from "ways-ui-vue/lib/locale-provider/en_US"; // ways-ui-vue lang

import Vue from "vue";

Vue.use(VueI18n);

const messages = {
  zh_CN: {
    ...zhLocale,
    ...iwaysZhLocale,
    ...waysUIZhLocale
  },
  en: {
    ...enLocale,
    ...iwaysEnLocale,
    ...waysUIEnLocale
  }
};

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: Cookies.get("language") || "zh_CN",
  // set locale messages
  messages
});

export default i18n;
